/** @namespace Reducers.ProtectiveEquipment */

import { GridReducer } from '../common/grid/grid.reducer';
import merge from 'lodash/merge';
import set from 'lodash/set';
import update from 'lodash/update';

/**
 * @function protectiveEquipmentReducer
 * @param state {object}
 * @param action {object}
 * @returns {object} Redux Store
 * @memberOf Reducers
 */
export function protectiveEquipmentReducer(state, action) {

    if (typeof state === 'undefined') {
        return {
            equipment: {
                testStatusList: [
                    {value: 'pass', label: 'Pass'},
                    {value: 'fail', label: 'Fail'}
                ],
                leadEquivalenceList: [],
                equipmentCategories: [],
                equipmentTypes: [],
                equipmentSubtypes: []
            },
            protectiveEquipmentGrid: merge(GridReducer(), {activeCount: 0, archiveCount: 0}, {
                filter: {
                    location: null,
                    category: null,
                    subtype: null,
                    type: null,
                    status: 'act',
                    equipmentId: null,
                    leadEquivalence: null,
                    testStatus: null
                }
            }),
            protectiveEquipmentHistoryGrid: merge(GridReducer(), {
                filter: {
                    equipmentId: null
                }
            }),
            protectiveEquipmentTestsGrid: merge(GridReducer(), {
                filter: {
                    equipmentId: null,
                    status: 'act'
                }
            }),
            protectiveEquipmentTestReportsGrid: merge(GridReducer(), {
                filter: {
                    equipmentId: null,
                    location: null,
                    category: null,
                    subtype: null,
                    type: null,
                }
            })
        };
    }

    switch (action.type) {
        case 'GRID_FILTER':
            if (action.id === 'protectiveEquipmentTestsGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentTestsGrid: set(GridReducer(state.protectiveEquipmentTestsGrid, set(action, 'type', 'PAGINATE')), 'filter.equipmentId', action.equipmentId)
                });
            }
        case 'LOCATION_SELECTED':
            if (action.id === 'protectiveEquipmentGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentGrid: set(GridReducer(state.protectiveEquipmentGrid, set(action, 'type', 'PAGINATE')), 'filter.location', action.uuid)
                });
            }
            if (action.id === 'protectiveEquipmentTestReportsGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentTestReportsGrid: set(GridReducer(state.protectiveEquipmentTestReportsGrid, set(action, 'type', 'PAGINATE')), 'filter.location', action.uuid)
                });
            }
        case 'EQUIPMENT_TYPE_SELECTED':
            if (action.id === 'protectiveEquipmentGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentGrid: set(GridReducer(state.protectiveEquipmentGrid, set(action, 'type', 'PAGINATE')), 'filter.type', action.equipmentType)
                });
            }
            if (action.id === 'protectiveEquipmentTestReportsGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentTestReportsGrid: set(GridReducer(state.protectiveEquipmentTestReportsGrid, set(action, 'type', 'PAGINATE')), 'filter.type', action.equipmentType)
                });
            }
        case 'EQUIPMENT_HISTORY_SELECTED':
            if (action.id === 'protectiveEquipmentHistoryGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentHistoryGrid: set(GridReducer(state.protectiveEquipmentHistoryGrid, set(action, 'type', 'PAGINATE')), 'filter.equipmentId', action.equipmentId)
                });
            }
        case 'PPE_TEST_STATUS_SELECTED':
            if (action.id === 'protectiveEquipmentTestsGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentTestsGrid: set(GridReducer(state.protectiveEquipmentTestsGrid, set(action, 'type', 'PAGINATE')), 'filter.status', action.status)
                });
            }
        case 'GRID_RESET':
            if (action.id === 'protectiveEquipmentGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentGrid: update(GridReducer(state.protectiveEquipmentGrid, action), 'filter', function(filter) {
                        return Object.assign({}, filter, {
                            location: null,
                            category: null,
                            type: null,
                            subtype: null,
                            status: 'act',
                            equipmentId: null,
                            leadEquivalence: null,
                            testStatus: null,
                        });
                    })
                });
            }
            if (action.id === 'protectiveEquipmentTestsGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentTestsGrid: update(GridReducer(state.protectiveEquipmentTestsGrid, action), 'filter', function(filter) {
                        return Object.assign({}, filter, {
                            status: 'act'
                        });
                    })
                });
            }
            if (action.id === 'protectiveEquipmentTestReportsGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentTestReportsGrid: update(GridReducer(state.protectiveEquipmentTestReportsGrid, action), 'filter', function(filter) {
                        return Object.assign({}, filter, {
                            location: null,
                            category: null,
                            subtype: null,
                            type: null,
                        });
                    })
                });
            }
        case 'SHOW_LOADING':
        case 'PAGINATE':
        case 'GRID_RELOAD':
        case 'GRID_FETCH':
            if (action.id === 'protectiveEquipmentGrid') {
                return Object.assign({}, state, set({}, action.id, Object.assign({}, GridReducer(state.protectiveEquipmentGrid, action), {
                    activeCount: action.activeCount,
                    archiveCount: action.archiveCount
                })));
            }
            if (action.id === 'protectiveEquipmentHistoryGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentHistoryGrid: GridReducer(state.protectiveEquipmentHistoryGrid, action)
                });
            }
            if (action.id === 'protectiveEquipmentTestsGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentTestsGrid: GridReducer(state.protectiveEquipmentTestsGrid, action)
                });
            }
            if (action.id === 'protectiveEquipmentTestReportsGrid') {
                return Object.assign({}, state, {
                    protectiveEquipmentTestReportsGrid: GridReducer(state.protectiveEquipmentTestReportsGrid, action)
                });
            }
        case 'EQUIPMENT_SWITCH':
            if (action.id === 'protectiveEquipmentGrid') {
                return Object.assign({}, state, set({}, action.id, set(GridReducer(state[action.id], {type: 'PAGINATE'}), 'filter.status', action.status)));
            }
        case 'LEAD_EQUIVALENCE_LIST':
            if ([
                'equipment'
            ].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        leadEquivalenceList: (action.data || []).map((item) => {
                            return { value: item.id, label: item.getValue() };
                        })
                    }
                }
            }
        case 'CATEGORY_LIST':
            if ([
                'equipment'
            ].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        equipmentCategories: action.data.map((item) => {
                            return { value: item.id, label: item.name }
                        })
                    }
                }
            }
        case 'TYPE_LIST':
            if ([
                'equipment'
            ].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        equipmentTypes: (action.data || []).map((item) => {
                            return { value: item.id, label: item.name };
                        })
                    }
                }
            }
        case 'SUBTYPE_LIST':
            if ([
                'equipment'
            ].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        equipmentSubtypes: (action.data || []).map((item) => {
                            return { value: item.id, label: item.name };
                        })
                    }
                }
            }
        case 'INPUT_SELECT':
        case 'INPUT_RADIO_CHANGE':
        case 'INPUT_TEXT_CHANGE':
            if (['protectiveEquipmentGrid', 'protectiveEquipmentTestReportsGrid'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: set(GridReducer(state[action.id], { type: 'PAGINATE' }), action.path, action.input)
                };
            }
        default:
            return state;
    }
}
